import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Panel } from 'react-bootstrap';
import { ButtonType, Button } from '@checkmarx/cx-ui';
import styles from '../style.scss'

@inject('translationsStore', 'twoFAStore') @observer

export default class DisableTwoFactor extends Component {
    componentWillMount() {
        this.props.twoFAStore.changeStepInProgress(false);
    }

    handleSubmitForm = (e) => {
        this.props.twoFAStore.changeStepInProgress(true);
        e.preventDefault();
        this.props.twoFAStore.disableTwoFactorAuth().then((response) => {
            if (response === true) {
                this.props.twoFAStore.currentStep = this.props.twoFAStore.twoFactorSteps.authoptions;
            }
            else {

            }
            this.props.twoFAStore.changeStepInProgress(false);
        });
    }

    render() {
        const { twoFactorSteps, stepInProgress } = this.props.twoFAStore;

        return (<div>
            <form onSubmit={this.handleSubmitForm}>
                <div className='tab-dialog subTitle'>
                    {this.props.translationsStore.translate('DISABLETWOFACTORTITLE')}
                </div>
                <Panel className='infoPanel'>
                    <div className='boldtext'> {this.props.translationsStore.translate('DISABLE_2FA_MESSAGE1')}</div>
                    <div style={{ paddingTop: '10px' }}>{this.props.translationsStore.translate('DISABLE_2FA_MESSAGE2')}. {this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE4')}<a style={{ cursor: 'pointer' }} onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.resetauthkey)}> {this.props.translationsStore.translate('RESET_RECOVERY_MESSAGE5')}</a></div>
                </Panel>
                <div className='buttonDiv'>
                    <Button
                        type="submit"
                        id="btnDisableTwoFactor"
                        text={this.props.translationsStore.translate('DISABLETWOFACTOR')}
                        inProgress={stepInProgress}
                    />
                    <Button
                        text={this.props.translationsStore.translate('BACK')}
                        onClick={() => this.props.twoFAStore.changeStep(twoFactorSteps.authoptions)}
                    />
                </div>
            </form>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/account/twoFA/disableTwoFactor/index.jsx